import { Component } from 'react';

import { Loader } from '@opendoor/bricks/core';
import { IAddressInputAddress } from '@opendoor/cinderblocks/growth/AddressInput/AddressInput';
import queryString from 'query-string';

import { createSellerInput } from '../../api';
import { setWidgetSource } from '../../helpers/localStorage';
import mapHistoryPush from '../../hocs/mapHistoryPush';
import { sellerGlobalPagePath } from '../../routes/pathBuilders';

interface IQueryParams {
  street1: string;
  city: string;
  state: string;
  postal_code: string;
  unit?: string;
  keywords: Array<string>;
  source: string;
}

interface IProps {
  location: {
    search: string;
  };
  pushPath: (path: string) => void;
}

class FlowCreateLead extends Component<IProps> {
  public componentDidMount() {
    const queryParams = queryString.parse(this.props.location.search) as unknown as IQueryParams;
    const address = queryParams as IAddressInputAddress;

    createSellerInput(address).then(({ token }) => {
      setWidgetSource(String(token), queryParams.source);
      this.props.pushPath(sellerGlobalPagePath({ token, page: 'address' }));
    });
  }

  public render() {
    return <Loader />;
  }
}

export default mapHistoryPush(FlowCreateLead);
